const Room = () => import('@/views/Room.vue');
const ProxyBootstrap = () => import('@/views/ProxyBootstrap.vue');

const routes = [
  {
    name: 'room',
    path: '/',
    component: Room
  },
  {
    name: 'proxy',
    path: '/proxy',
    component: ProxyBootstrap
  },
  {
    name: '404',
    path: '*',
    redirect: { name: 'room' }
  }
];

export default routes;
